import checkout from './checkout';
import communes from './communes';
import accommodations from './accommodations';
import steps from './steps';
import discounts from './discounts';
import i18n from './i18n';

export default { communes, checkout, accommodations, steps, discounts, i18n };
